import { post, DELETE, get } from '../axios'

// 新增top banner
export function homepage_material_topbanner_v1_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/topbanner/v1/add`,
    map,
    option
  ).then(response => response)
}

// 删除top banner
export function homepage_material_topbanner_v1_delete_materialId_delete(
  map,
  option
) {
  return DELETE(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/topbanner/v1/delete/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// top banner详情
export function homepage_material_topbanner_v1_detail_materialId_get(
  map,
  option
) {
  return get(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/topbanner/v1/detail/${map.materialId}`,
    map,
    option
  ).then(response => response)
}

// 编辑top banner
export function homepage_material_topbanner_v1_edit_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/topbanner/v1/edit`,
    map,
    option
  ).then(response => response)
}

// top banner列表
export function homepage_material_topbanner_v1_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_HOMEPAGE}/homepage/material/topbanner/v1/list`,
    map,
    option
  ).then(response => response)
}

// 导航详情
export function nav_v2_detail_id_get(map, option) {
  return get(
    `${process.env.VUE_APP_NAV}/nav/v2/detail/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 获取人群列表
export function nav_v2_people_types_get(map, option) {
  return get(
    `${process.env.VUE_APP_NAV}/nav/v2/people/types`,
    map,
    option
  ).then(response => response)
}

// 保存导航
export function nav_v2_save_post(map, option) {
  return post(`${process.env.VUE_APP_NAV}/nav/v2/save`, map, option).then(
    response => response
  )
}
